import React, { useState, useEffect } from "react";
import { getIdData, addData, updateData } from "../../../lib/studentnotes";
import { useNavigate, useParams } from "react-router-dom";
import TextEditor from "../../ui/editor";
import { useAuth } from "../../../usercontext";
import STopMenu from "../../../components/student/topmenu/topmenu";
import S911TopMenu from "../../student911/topmenu/topmenu";
import S12TopMenu from "../../student12/topmenu/topmenu";

export default function StudentNotesEdit() {
  const [noteData, setNoteData] = useState("");
  const [title, setTitle] = useState("");
  const { profile } = useAuth();
  const [data, setData] = useState([]);

  const navigate = useNavigate();
  let { slug, Id } = useParams();

  const studentId = profile.id;
  //const studentClass = profile.class;
  //console.log("Geldi",profile.id);

  async function GetData() {
    const noteData = await getIdData(Id);
    console.log("noteData", noteData);
    setData(noteData);
    setTitle(noteData[0].title);
    setNoteData(noteData[0].description);
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    console.log("title", title, noteData, studentId);

    if (slug === "Add") {
      console.log("Add");
      await addData({
        title: title,
        description: noteData,
        studentId: studentId, //,
        //lessonType:lessonType
      });
    } else {
      console.log("Update");
      await updateData({
        id: Id,
        title: title,
        description: noteData, //,
        //lessonType:lessonType
      });
    }

    navigate("/student/student-notes");
  };

  useEffect(() => {
    if (slug !== "Add") {
      GetData();
    }
  }, [slug]);
  const isStudent911 = profile?.role === "Student911";
  const isStudent12 = profile?.role === "Student12";
  const isStudent = profile?.role === "Student";
  return (
    <>
      {isStudent && <STopMenu slug={studentId} activeMenu="LessonsEdit" />}
      {isStudent911 && <S911TopMenu slug={studentId} activeMenu="LessonsEdit" />}
      {isStudent12 && <S12TopMenu slug={studentId} activeMenu="LessonsEdit" />}

      <div className="col-12">
        <div className="settings-widget profile-details">
          <div className="settings-menu p-0">
            <div className="profile-heading">
              <h3>{slug === "Add" ? "Add Note" : "Update Note"}</h3>
            </div>
            <div className="checkout-form personal-address add-course-info ">
              <form role="form" onSubmit={handleSubmit}>
                <div className="row mx-auto">
                  <div className="col-9">
                    <div className="form-group">
                      <label className="form-control-label">Title</label>
                      <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        className="form-control"
                        placeholder="Enter Title"
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group ">
                    <label className="form-control-label">Description</label>
                    <div id="editor">
                      <TextEditor value={noteData} setValue={setNoteData} />
                    </div>
                  </div>
                  <div className="update-profile d-flex justify-content-between">
                    <button type="submit" className="btn btn-primary">
                      {slug === "Add" ? "Add Note" : "Update Note"}
                    </button>
                    <button
                      onClick={() => navigate(-1)}
                      className="btn btn-black btn-sm"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
